import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "juou-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "juou-title" }, "首页顶部", -1)
const _hoisted_3 = {
  class: "juou-card",
  style: {"margin-top":"16px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "juou-title" }, "首页底部", -1)

import Advertising from '@/components/Advertising.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(Advertising, { position: "hometop" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(Advertising, { position: "homebottom" })
    ])
  ], 64))
}
}

})